import { Modal } from 'shared-components';
import { Button, Text } from '@chakra-ui/react';

export interface IProps {
  onClose: () => void;
}

const IntakeChangeConflictModal = (props: IProps) => {
  const { onClose } = props;

  return (
    <Modal
      id="update-intake-conflict"
      show={true}
      title={'Action Not Permitted'}
      onClose={onClose}
      maxWidthPx={630}
      backgroundColor={'#4a535b'}
      textColor={'#fff'}
      headerFontSize={18}
      headerMargin={22}
      paddingTop={20}
      footer={
        <Button id="submit-close-button" onClick={onClose} size="lg" variant="solid">
          Return to CAS Checklist
        </Button>
      }
    >
      <Text mb={0}>
        The new start date falls within a different intake. Please update the start date on your university student
        management system. Once updated simply reimport the student / wait for the next sync and the system will create
        a new record for the new intake.
      </Text>
    </Modal>
  );
};

export default IntakeChangeConflictModal;
